import React, { Component } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import DataTable from "react-data-table-component";
import { read, utils } from "xlsx";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import CommonAlert from "../common/Commonalert";
import Popup from "../common/popup";
import ChangePassword from "./changepassword";
import EditvendorDetails from "./editvendorDetails";
import CustomerImport from "../common/CustomerImport";
import { dateformatwithuktime } from "../utilityfunctions";
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import * as XLSX from "sheetjs-style";
import { saveAs } from "file-saver";
import moment from "moment";
// const excludeTestIds = [
//   "K2BTE003", "K2BTE005", "K2BTE001", "K2BTE002",
//   "TESTA004", "TESTA005", "TESTA007", "IEPIZ001",'TESTA099'
// ];
class Vendors extends Component {
  
  constructor(props) {
    super(props);
    this.showConfirmationDialog = this.showConfirmationDialog.bind(this);
    this.showReasonDialog = this.showReasonDialog.bind(this);
    this.state = {
      searchTextVal: "",
      transformedAccounts:[],
      accounts: [],
      tempaccounts: [],
      loading: true,
      popupView: "",
      showPopup: false,
      //showLoader: false,
      Vendoremailadd: "",
      alertMessage: "",
      alertPopup: false,
      visibleAlert: false,
      customeremail: "",
      customeraccount: "",
      showDialog: false,
      editvendor: false,
      isActive: [],
      reason: "",
      showReasonPopup: false,
      reasonError: "",
      popuplogView: "",
      popupPricebandView: "",
      selectedFile: null,
      isUploading: false,
      uploadMessage: "",
      showcustomPopup: false,
      popupImportView: false,
      importValue: "",
      searchResults: [],
      statusFilterVal: "",
      visibledeleteAlert: false,
      sortBy: 'all',
      range: '',
      showDatePicker: false,
      fromDate: null,
      toDate: null,
      selectedCategories: ["pizza", "pasta", "burrito","desserts"],
      searchField: "accountCode",
      searchFieldtxt: "Account Code",
      suggestions: [],
      subDepotList: [],
      mainDepotList: [],
      depots: [],
      fullText: false,
      restrictedAccounts: [],
      isEmailToBeSent: "",
      emailCount: "",
      showExportAlert: false,
      showNoDataAlert: false,
    };
    this.fileInputRef = React.createRef();

    if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";

    if (
      JSON.parse(sessionStorage.getItem("authData")) != "" &&
      !JSON.parse(
        sessionStorage.getItem("authData")
      ).adminRole.permissions.includes("manage_customers")
    ) {
      window.location.href = "/unauthorized";
    }

    this.handleImport = this.handleImport.bind(this);
  }

  priceFormat = (price) => {
   
    return price.toLocaleString("en-US", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: 2,
    });
};

  
  handleImport($event) {
    const files = $event.target.files;
    if (files.length) {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;

        var loginDetails = {};
        if (window.sessionStorage.getItem("authData")) {
          loginDetails = JSON.parse(window.sessionStorage.getItem("authData"));
        }

        if (sheets.length) {
          let rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);

          let URL = BaseUrl + "admin/account/import";

          const payload = {
            data: rows,
            selectedFields: selectedFields,
          };

          http
            .post(URL, payload)
            .then((response) => {
              this.getAccounts();
            })
            .catch((error) => {
              console.log(error);
            });
        }
      };
      reader.readAsArrayBuffer(file);
    }
  }

  

  getAccounts() {
    this.setState({ loading: true });
    var loginDetails = {};
    if (window.sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(window.sessionStorage.getItem("authData"));
    }

  let URL = BaseUrl + "admin/account";
  http
    .get(URL, {}, { timeout: 180000 })
    .then((response) => {
      const accountsData = response.data.data;
      const thresholdDate = new Date("2024-09-02"); // 02/09/2024

      const transformedAccounts = accountsData.map(account => {
        const createdAt = new Date(account.createdAt);
        const updatedAt = new Date(account.updatedAt);

        if (createdAt < thresholdDate) {
          account.createdAt = thresholdDate.toISOString();
        }

        if (updatedAt < thresholdDate) {
          account.updatedAt = thresholdDate.toISOString();
        }

        return account;
      });

      const uniqueSectors = [...new Set(
        transformedAccounts
          .map((acc) => acc.Sectors)
          .filter((sector) => sector && sector.trim() !== "")
      )];

      this.setState({
        accounts: transformedAccounts,
        loading: false,
        originalAccounts: transformedAccounts,
        tempaccounts: transformedAccounts,
        alertPopup: false,
        alertMessage: "",
        sectorOptions: uniqueSectors,
      });
    })
    .catch((err) => {
      console.log(err);
      this.setState({
        alertPopup: true,
        alertMessage: `The Server is busy, please try after sometime`,
      });
    });
    let URL1 = BaseUrl + `admin/getdepots`;
    http
      .get(URL1)
      .then((response) => {
        let responseData = response.data.data;

        const uniqueDepots = Array.from(new Set(responseData.map(item => item.mainDepot)))
          .map(mainDepot => responseData.find(item => item.mainDepot === mainDepot));
        this.setState({ subDepotList: responseData });
        this.setState({ depots: responseData });
        this.setState({ mainDepotList: uniqueDepots })

      })
      .catch((err) => {
        console.log(err);
      });

  }

  editVendorDetails(vendor) {
    this.setState({
      editvendor: true,
      VendorDetails: vendor,
      alertMessage: "",
    });
  }
  ediVendorsdetails = (formData) => {
    let URL = BaseUrl + "admin/editaccount/" + formData.cid;

    this.setState({ loading: true });

    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }

    http
      .put(URL, formData)
      .then((response) => {
        let responseData = response.data.success;
        if (responseData) {
          this.setState({
            alertPopup: true,
            alertMessage: "Account Details Updated Successfully",
          });
        }
        this.setState({ editvendor: false, loading: false });
        //setTimeout(this.getAccounts(),1000);
        setTimeout(() => {
          window.location.reload();
        }, 2000); // 2000 milliseconds (2 seconds)
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  };
  // Define the sanitizeString function
  sanitizeString = (input) => {
    // Remove spaces or commas at the beginning and end of the string
    let sanitized = input.trim().replace(/^,|,$/g, "");

    // // Remove spaces around commas
    sanitized = sanitized.trim();

    return sanitized;
  };

  viewVendorDetails(vendor) {
    this.setState({ alertPopup: false, alertMessage: "" });
    let addressFields = [
      this.sanitizeString(vendor.accountAddress1 || ""),
      this.sanitizeString(vendor.accountAddress2 || ""),
      this.sanitizeString(vendor.accountAddress3 || ""),
      this.sanitizeString(vendor.accountAddress4 || ""),
      this.sanitizeString(vendor.accountAddress5 || ""),
    ];
    var accountaddress = addressFields
      .filter((field) => field !== undefined && field != "")
      .join(", ");
    let popupResult = (
      <Popup
        extClass="order-pop info-poup"
        headMoreTxt={
          <>
            <div className="order-top">
              <div className="head">
                <h4>Customer Details</h4>
              </div>
            </div>
          </>
        }
        bodyMoreTxt={
          <>
            <div className="order-top">
              <div className="bottom vendor-details vendor-table-view">
                <table className="vendor-table">
                  <tr>
                    <td>Account Code</td>
                    <td>{vendor.accountCode}</td>
                  </tr>
                  <tr>
                    <td>Name</td>
                    <td>{vendor.accountName}</td>
                  </tr>
                  <tr>
                    <td>Email Address</td>
                    <td>{vendor.accountEmail}</td>
                  </tr>
                  {vendor.accountTelephone !== "0" && (
                    <tr>
                      <td>Telephone Number</td>
                      <td>{vendor.accountTelephone}</td>
                    </tr>
                  )}
                  <tr>
                    <td>Address</td>
                    <td>{accountaddress}</td>
                  </tr>
                  <tr>
                    <td>Accept CWO Only</td>
                    <td>{vendor.accountPaymentMethod}</td>
                  </tr>
                  <tr>
                    <td>Route Days</td>
                    <td>{vendor.accountDeliverableDays}</td>
                  </tr>
                  <tr>
                    <td>Price Band</td>
                    <td>{vendor.accountPriceListId}</td>
                  </tr>
                  <tr>
                    <td>Credit Limit</td>
                    <td>{vendor.CreditLimit}</td>
                  </tr>
                  <tr>
                    <td>Account Objective1</td>
                    <td>{vendor.AccountObjective1}</td>
                  </tr>
                  <tr>
                    <td>Account Objective2</td>
                    <td>{vendor.AccountObjective2}</td>
                  </tr>
                  <tr>
                    <td>Website Access</td>
                    <td>{vendor.accountWebSiteAccess}</td>
                  </tr>
                  {vendor.Sectors && (
                    <tr>
                      <td>Sector</td>
                      <td>{vendor.Sectors}</td>
                    </tr>
                  )}
                  <tr>
                    <td>Main Depot</td>
                    <td>{vendor.mainDepot}</td>
                  </tr>
                  <tr>
                    <td>Local Depot</td>
                    <td>{vendor.subDepot}</td>
                  </tr>
                  <tr>
                    <td>Created Date</td>
                    <td>{dateformatwithuktime(vendor.createdAt)}</td>
                  </tr>
                  <tr>
                    <td>Updated Date</td>
                    <td>{dateformatwithuktime(vendor.updatedAt)}</td>
                  </tr>
                  {vendor.lastLogin && (<tr>
                    <td>Last Login</td>
                    <td>{dateformatwithuktime(vendor.lastLogin)}</td>
                  </tr>)}
                </table>
              </div>
            </div>
          </>
        }
        closebtn={
          <>
            <span
              onClick={() => this.setState({ popupView: "" })}
              className="close"
            ></span>
          </>
        }
      />
    );

    this.setState({ popupView: popupResult });
  }

  showConfirmationDialog = () => {
    // Only validate email option when activating
    if (this.state.confirmationAction.action === "activate" && !this.state.isEmailToBeSent) {
      this.setState({ emailError: true });
      return;
    }
    if (this.state.reason !== "") {
      this.setState({
        alertPopup: false,
        showReasonPopup: false,
        showDialog: true,
      });
    } else {
      this.setState({ reasonError: true });
    }
  };

  showReasonDialog = (accountcode, action) => {
    this.setState(
      {
        showReasonPopup: true,
        reasonError: false,
        isEmailToBeSent: "",
        emailCount: null, // Reset email count
        confirmationAction: { accountcode, action },
      },
      () => { }
    );
  };

  hideConfirmationDialog = () => {
    this.setState({
      alertPopup: false,
      showDialog: false,
      showReasonPopup: false,
      reason: "",
      reasonError: false,
    });
  };

  confirmActionHandler = () => {
    const { accountcode, action } = this.state.confirmationAction;
    this.confirmAction(accountcode, action);
    this.hideConfirmationDialog();
  };

  toggleCustomerStatus = (accountcode) => {
    const { accounts } = this.state;
    const account = accounts.find((p) => p.accountCode === accountcode);
    const isCurrentlyActive = account.accountStatus;

    const action = isCurrentlyActive === "active" ? "deactivate" : "activate";

    this.showReasonDialog(accountcode, action);
  };
  confirmAction = (accountcode, action) => {
    const { confirmationAction } = this.state;
    const { accounts, isActive, reason } = this.state;
    let URL = BaseUrl + "admin/accountstatus";
    const payload = {
      accountCode: accountcode,
      accountStatus: action === "activate" ? "active" : "deactive",
    };
    // Add email feiled only if activating
    if (action === "activate") {
      payload.isEmailToBeSent = this.state.isEmailToBeSent;
    }
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }

    http
      .put(URL, payload)
      .then(async (response) => {
        if (response.status === 200) {
          //changed by k2b Sangeetha for activate/Deactivate Customer
          this.setState((prevState) => {
            const updatedAccounts = prevState.accounts.map((account) =>
              account.accountCode === accountcode
                ? { ...account, accountStatus: payload.accountStatus }
                : account
            );
            const updatedTempAccounts = prevState.tempaccounts.map((account) =>
              account.accountCode === accountcode
                ? { ...account, accountStatus: payload.accountStatus }
                : account
            );
            return {
              accounts: updatedAccounts,
              tempaccounts: updatedTempAccounts,
            };
          });
          //changed by k2b Sangeetha for activate/Deactivate Customer
          let noteURL = BaseUrl + "admin/accountlog";
          let noteText ='';
          if(this.state.isEmailToBeSent==="yes" && action === "activate"){
            noteText= action + " - " +reason+ " - Intro email sent" ;
          }
          else{
             noteText= action + " - " + reason ;
          }
          const notepayload = {
            accountCode: accountcode,
            noteText: noteText,
            createdBy: loginDetails.adminName,
          };
          http.post(noteURL, notepayload).then(async (response) => {
            const actionMsg =
              action.trim() === "activate" 
              ? this.state.isEmailToBeSent==="yes"? `Customer (${accountcode}) has been activated. The introduction email will be sent shortly`:`Customer (${accountcode}) has been activated successfully!` 
              : `Customer (${accountcode}) has been deactivated successfully!`;
              console.log(actionMsg);
            this.setState({
              showcustomPopup: true,
              uploadMessage: actionMsg,
            });
          });
          this.hideConfirmationDialog();
        }
      })
      .catch((error) => {
        console.error("Error updating customer status:", error);
        alert("Failed to update customer status.");
      });
  };
  /* added by k2b vivek customer active and deactive status */
  changePassword(customer) {
    this.setState({ showPopup: true });
    this.setState({
      Vendoremailadd: customer.accountEmail,
      Vendoraccountcode: customer.accountCode,
    });
  }

  triggerEmail = (customer) => {
    this.setState({ showPopup: false, alertMessage: '', visibleAlert: true, customeremail: customer.accountEmail, customeraccount: customer.accountCode });

    //this.setState({alertPopup: true, alertMessage: 'For demo purpose we had disabled the email functionality!!!',visibleAlert:false,customeremail:'', showPopup:false});
  };
  CustomerStatuslog = (accountCode) => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }

    let URL = BaseUrl + "admin/accountlog/" + accountCode;

    http
      .get(URL)
      .then(async (response) => {
        let responseData = [];
        responseData = response.data.data;
        this.viewlogDetails(responseData, accountCode);
      })
      .catch((error) => {
        console.error("Error updating customer status:", error);
      });
  };
  formatDate(dateString) {
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  }

  viewlogDetails(acc_det, accountCode) {
    let popupResult = (
      <Popup
        extClass="info-poup show"
        closebtn={
          <>
            <span
              onClick={() => this.setState({ popuplogView: "" })}
              className="close"
            ></span>
          </>
        }
        headMoreTxt={
          <>
            <div className="order-top">
              <h4>
                <span>Customer Status Log Details - {accountCode}</span>
              </h4>
            </div>
          </>
        }
        bodyMoreTxt={
          <>
            <div className="bottom vendor-details acc-log">
              {acc_det && acc_det.length > 0 ? (
                acc_det.map((acc_item) => {
                  // const [accstatus, notes, introEmailSent] = acc_item.noteText.split(/-(.+)/);
                  const [accstatus, notes, introEmailSent=''] = acc_item.noteText.split(" - ");                 
                  let accactionstatus =
                    accstatus.trim() === "activate"
                      ?  introEmailSent ? "Activated"+" - "+introEmailSent :"Activated"
                      : "Deactivated";
                  let createdby = acc_item.createdBy ? (
                    <>
                      <span className="log-user">{acc_item.createdBy}</span>
                      <span className="log-line">|</span>
                    </>
                  ) : (
                    ""
                  );
                  return (
                    <div className="info-item">
                      <div className="info-innr">
                        <div className="flex-log-hdr">
                          <p>
                            <span className="labeltxt acn-by">
                              {accactionstatus}
                            </span>
                          </p>
                          <div className="hdrlog-rit">
                            {createdby}
                            <span className="log-date">
                              {dateformatwithuktime(acc_item.createdAt)}
                            </span>
                          </div>
                        </div>
                        <p>
                          <span className="labeltxt log-reason">Reason: </span>
                          {notes ? notes.trim() : ""}
                        </p>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="no-logs">No logs available</div>
              )}
            </div>
          </>
        }
      />
    );

    this.setState({ popuplogView: popupResult });
  }

  triggerMail = () => {
    let URL = BaseUrl + "forgotpassword";
    let payload = {
      emailaddress: this.state.customeremail,
      accountCode: this.state.customeraccount,
      type: "admin",
    };

    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    this.setState({ visibleAlert: false, loading: true });

    http
      .post(URL, payload)
      .then((response) => {
        this.setState({
          alertPopup: true,
          alertMessage:
            "Reset password link has been sent to your Email Address",
          loading: false,
          customeremail: "",
          showPopup: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  alertPopupclose = () => {
    this.setState({
      visibleAlert: false,
      customeremail: "",
      customeraccount: "",
      alertPopup: false,
    });
  };

  DeletePopupclose = () => {
    this.setState({
      visibledeleteAlert: false,
      customeraccount: "",
      alertPopup: false,
    });
  };

  closepopup = (alrtpopup, alrtmsg) => {
    this.setState({
      showPopup: false,
      alertPopup: alrtpopup,
      alertMessage: alrtmsg,
    });
  };

  editclosepopup = (alrtpopup, alrtmsg) => {
    this.setState({
      editvendor: false,
      alertPopup: alrtpopup,
      alertMessage: alrtmsg,
      showPopup: false,
    });
  };

  viewProducts = (vendor)=>{
    this.setState({ alertPopup: false, alertMessage: "" });
    let URL = BaseUrl + `admin/productsbasedonband/${vendor.accountPriceListId}`;
    http
      .get(URL)
      .then((response) => {
        let responseProducts = response.data.data;

        this.setState({ originalProducts: responseProducts }, () => { this.viewProductsPopup(responseProducts, vendor.accountPriceListId) }
        );

      })
      .catch((err) => {
        console.log(err);
      });
  }
  
  getFilteredProducts = (responseProducts) => {
    const {selectedCategories } = this.state;
    // Category mapping
     const categoryMap = {
      pizza: ['1'],
      pasta: ['10', '13'],
      burrito: ['11', '12'],
      desserts: ['14']
    };
    const selectedCategoryIds = selectedCategories
    .flatMap((category) => categoryMap[category]|| []);

    responseProducts.sort((a, b) => parseFloat(a.PDP_Price1) - parseFloat(b.PDP_Price1));

  return responseProducts.filter((prd) => selectedCategoryIds.includes(prd.categoryId));
  };

 
  viewProductsPopup =(responseProducts,priceband)=>{
      const filteredProducts = this.getFilteredProducts(responseProducts);
   
      let popupResult = (<Popup
        extClass="order-pop info-poup"
        headMoreTxt={
          <>
            <div className="order-top">
              <div className="head">
                <h4>Product Details - {responseProducts[0].PDP_Reference}</h4>
              </div>
            </div>
          </>
        }
        bodyMoreTxt={
          <>
            <div className="order-top">
              <div className="bottom product-details vendor-table-view">
              <div className="custom_check-box">
                      <div className='edit-free-cat-chks'>
                      <div className="check-box inline">
                          <input
                            type="checkbox"
                            id="cat01"
                            name="pizza"
                            onChange={this.handleCategoryChange}
                            checked={this.state.selectedCategories.includes("pizza")}
                          />
                          <label for="cat01">Pizza <span className="ctgry-icon pizza"></span></label>
                        </div>
                        <div className="check-box inline">
                          <input
                            type="checkbox"
                            id="cat02"
                            name="pasta"
                            onChange={this.handleCategoryChange}
                            checked={this.state.selectedCategories.includes("pasta")}
                          />
                          <label for="cat02">Pasta, Rice & Noodle Sauces <span className="ctgry-icon pasta"></span></label>
                        </div>
                        <div className="check-box inline">
                          <input
                            type="checkbox"
                            id="cat03"
                            name="burrito"
                            onChange={this.handleCategoryChange}
                            checked={this.state.selectedCategories.includes("burrito")}
                          />
                          <label for="cat03">Burrito <span className="ctgry-icon burrito"></span></label>
                        </div>
                         <div className="check-box inline">
                        <input
                          type="checkbox"
                          id="cat04"
                          name="desserts"
                          onChange={this.handleCategoryChange}
                          checked={this.state.selectedCategories.includes("desserts")}
                        />
                        <label for="cat04">Desserts <span className="ctgry-icon desserts"></span></label>
                      </div>
                               
                      </div>
                  </div>
                         
                <table className="vendor-table">
                   <tr>
                    <th>Product</th>
                    <th>Unit of Sale</th>
                    <th>Price</th>
                  </tr>
                      
                  {filteredProducts?.length > 0 ?(
                  filteredProducts.map((product) => (<tr>
                    <td>{`${product.productDescription} (${
                          product.productNumber.includes("_")
                            ? product.productNumber.substring(0, product.productNumber.indexOf("_"))
                            : product.productNumber
                        })`}   <a
                        className="title-tooltip title-right"
                        data-title={product.categoryId === "1"
                          ? "PIZZA"
                          : product.categoryId === "10" || product.categoryId === "13"
                            ? "PASTA, RICE & NOODLE SAUCES"
                          : product.categoryId === "14"
                            ? "DESSERTS"
                            : "BURRITO"}
                      >
                        {/* <i className="fa fa-th-list" aria-hidden="true"></i> */}
                        <span className={`ctgry-icon ${
                            product.categoryId === "1"
                              ? "pizza"
                              : product.categoryId === "10" || product.categoryId === "13"
                              ? "pasta"
                            : product.categoryId === "14"
                            ? "desserts"  
                            : "burrito"
                          }`}></span>
                      </a></td>
                    <td>{product.packageSize}</td>
                    <td>{this.priceFormat(Number(product.PDP_Price1))}</td>
                   
                  </tr>))):(<tr>
                      <td colSpan="3">No products found.</td>
                    </tr>)}
                  
                  
                </table>
              </div>
            </div>
          </>
        }
        closebtn={
          <>
            <span
            onClick={() => this.setState({ popupPricebandView: "", selectedCategories: ['pizza', 'pasta', 'burrito','desserts'] })}
              className="close"
            ></span>
          </>
        }
      />);
   
    this.setState({ popupPricebandView: popupResult });
  }



  handleCategoryChange = (event) => {
    const category = event.target.name;
  
    this.setState(
      (prevState) => {
        let updatedCategories;
        if (prevState.selectedCategories.includes(category)) {
          updatedCategories = prevState.selectedCategories.filter(
            (item) => item !== category
          );
        } else {
          updatedCategories = [...prevState.selectedCategories, category];
        }
  
        return {
          selectedCategories: updatedCategories,
         
        }
      },
      () => {
        // Callback function to ensure the state has been updated
        this.viewProductsPopup(this.state.originalProducts);
        
      }
    );
  };


  componentDidMount() {
    this.fetchRestrictedAccounts();
    this.getAccounts();
  }

  handleReset = () => {
    this.setState({
      searchTextVal: "",
      searchField: "accountCode",
      searchFieldtxt:"Account Code",
      accounts: this.state.tempaccounts,
      showPopup: false,
      alertPopup: false,
      suggestions: [],
    }, this.applyFilters);
  };
// field-selection and auto suggestion
  // Function to handle field selection change
  handleFieldChange = (e) => {
    this.setState({
      searchField: e.target.value,
      searchFieldtxt:e.target.options[e.target.selectedIndex].text,
      searchTextVal: "",
      suggestions: [],
     
    });
  };
  handleSuggestionClick = (selectedValue) => {
    this.setState({ searchTextVal: selectedValue, suggestions: [] }, () => {
      this.applyFilters(true); // Pass true for exact match
  });
  };
  //Auto-Suggestions for Price Band
  handleChange = (value) => {
    this.setState({ searchTextVal: value, alertPopup: false, showPopup: false }, this.applyFilters);
    if (this.state.searchField === "accountPriceListId") {
    if (value.trim() === "") {
      this.setState({ suggestions: [] });
      return;
    }
    const suggestions = [...new Set(this.state.tempaccounts
      .map((acc) => acc.accountPriceListId)
      .filter((item) => item && item.toLowerCase().includes(value.toLowerCase()))
    )];
    this.setState({ suggestions });
  }
};
//field-selection and auto suggestion
  handleReasonChange = async (value) => {
    this.setState({ reason: value, reasonError: false }, () => { });
  };

  handleStatusChange = (value) => {
    this.setState({ statusFilterVal: value }, this.applyFilters);
  };

  triggerSessionDelete = (customer) => {
    this.setState({ visibledeleteAlert: true, customeraccount: customer });

  };

  triggerDelete = () => {
    let URL = BaseUrl + `admin/deletesession/${this.state.customeraccount}`;

    this.setState({ visibledeleteAlert: false, loading: true });

    http
      .delete(URL)
      .then((response) => {
        this.setState({
          alertPopup: true,
          alertMessage:
            `Session has been deleted successfully for the account ${this.state.customeraccount}`,
          loading: false,

        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleSearchClick = () => {
    this.setState({ suggestions: [] }, () => {
        this.applyFilters(false); // Regular filtering (includes)
    });
};

  fetchRestrictedAccounts() {
  http.get(BaseUrl + 'admin/accountcodelist')
    .then((res) => {
      const ids = res.data?.data?.map(acc => acc.accountCode);
      this.setState({ restrictedAccounts: ids || [] });
    })
    .catch((err) => {
      console.error("Failed to load restricted accounts", err);
    });
}

  applyFilters = (exactMatch = false) => {
    const { tempaccounts, searchTextVal, searchField, statusFilterVal } = this.state;
    let lowercasedText = searchTextVal.toLowerCase().trim();
    let lowercasedStatus = statusFilterVal.toLowerCase().trim();

    // Start from the full dataset
    let filteredData = tempaccounts;

    // Apply status filter if active
    if (lowercasedStatus) {
      filteredData = filteredData.filter((item) =>
        item.accountStatus && item.accountStatus.toLowerCase() === lowercasedStatus
      );
      filteredData = filteredData.filter(account => !this.state.restrictedAccounts.includes(account.accountCode));
    }

    // Apply text filter if search text is entered
    if (lowercasedText) {
      filteredData = filteredData.filter((item) => {
        const accountCode = item.accountCode;
        const isExcluded = this.state.restrictedAccounts.includes(accountCode);

        if (searchField === "accountName") {
          return item.accountName.toLowerCase().includes(lowercasedText);
        } else if (searchField === "accountCode") {
          return item.accountCode.toLowerCase().includes(lowercasedText);
        } else if (searchField === "accountEmail") {
          return item.accountEmail.toLowerCase().includes(lowercasedText);
        } else if (searchField === "accountPriceListId") {
          if (isExcluded) return false;
          return exactMatch
            ? item.accountPriceListId.toLowerCase() === lowercasedText
            : item.accountPriceListId.toLowerCase().includes(lowercasedText);
        } else if (searchField === "Sectors") {
          if (isExcluded) return false;
          return item.Sectors?.toLowerCase() === lowercasedText;
        } else if (searchField === "mainDepot") {
          if (isExcluded) return false;
          return item.mainDepot?.toLowerCase() === lowercasedText;
        } else if (searchField === "subDepot") {
          if (isExcluded) return false;
          return item.subDepot?.toLowerCase() === lowercasedText;
        }
        return false;
      });
    }
    this.setState({ accounts: filteredData, searchResults: filteredData });
  };


  filterData = (value, filterType = "search") => {
    const lowercasedValue = value.toLowerCase().trim();
    let baseData = filterType === "status" && this.state.searchTextVal ? this.state.searchResults : this.state.tempaccounts;
    let filteredData = [];

    if (filterType === "status") {
      // Filtering by active/deactive status within search results or full dataset
      if (lowercasedValue === "active" || lowercasedValue === "deactive") {
        filteredData = baseData.filter((item) =>
          item.accountStatus && item.accountStatus.toString().toLowerCase() === lowercasedValue
        );
        filteredData = filteredData.filter(account => !this.state.restrictedAccounts.includes(account.accountCode));
      } else {
        filteredData = baseData;
      }
    }
    else {
      // Search filter: applies text-based filtering on the full dataset
      filteredData = this.state.tempaccounts.filter((item) => {
        return (
          item.accountName.toLowerCase().includes(lowercasedValue) ||
          item.accountCode.toLowerCase().includes(lowercasedValue) ||
          item.accountEmail.toLowerCase().includes(lowercasedValue) ||
          item.accountPriceListId.toLowerCase().includes(lowercasedValue) ||
          item.Sectors?.toLowerCase().includes(lowercasedValue) ||
          item.mainDepot?.toLowerCase().includes(lowercasedValue) ||
          item.subDepot?.toLowerCase().includes(lowercasedValue)
        );
      });
      this.setState({ searchResults: filteredData });
    }

    this.setState({ accounts: filteredData });
  };

  handlesortbyChange = (value) => {
    this.setState({ sortBy: value, period: "",periodtext:"",showDatePicker: false, range: '', fromDate: '', toDate: '', alertPopup: false, alertMessage: "", }, () => {
      // Call API to get all records if 'sortBy' is 'all'
      if (value === "all") {
        this.getAccounts(); // Call the API function 
      }
    });
  };
  handlesortChange = (value, text) => {
    //console.log(text,'text');
    this.setState({ period: value,periodtext:text, showDatePicker: false });
    if (value === 'custom') {
      this.setState({ showDatePicker: true, range: value });
    } else {

      this.setState({ range: value, showDatePicker: false, fromDate: '', toDate: '' }, () => {
        const payload = {
          filterby: this.state.sortBy,
          period: value,
          datefrom: "",
          dateto: ""
        };
        this.callApi(payload);
      });
    }


  };

  handleFromDateChange = (date) => {
    this.setState({ fromDate: date }, this.callApiIfDatesSelected);
  };

  handleToDateChange = (date) => {
    this.setState({ toDate: date }, this.callApiIfDatesSelected
    );
  };
 DateChange = (value, type) => {
  const { toDate } = this.state;

  if (type === "from") {
    if (toDate && value > toDate) {
      // Reset toDate if fromDate is later than toDate
      this.setState({ fromDate: value, toDate: "", dateinvalid_error: true });
    } else {
      this.setState({ fromDate: value, dateinvalid_error: false }, this.callApiIfDatesSelected);
    }
  } else if (type === "to") {
    const { fromDate } = this.state;
    if (fromDate && fromDate > value) {
      this.setState({ toDate: "", dateinvalid_error: true });
    } else {
      this.setState({ toDate: value, dateinvalid_error: false }, this.callApiIfDatesSelected);
    }
  }
};

  handleButtonClick = () => {
    this.fileInputRef.current.click();
  };

  handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      this.setState({
        selectedFile: file,
        uploadMessage: "",
        showPopup: false,
      });
    }
  };

  handleUpload = (file, selectedFields) => {
    //const file = this.state.selectedFile;
    if (file) {
      const reader = new FileReader();
      this.setState({ isUploading: true });
      reader.onload = (event) => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;

        var loginDetails = {};
        if (window.sessionStorage.getItem("authData")) {
          loginDetails = JSON.parse(window.sessionStorage.getItem("authData"));
        }

        if (sheets.length) {
          let rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);

          let URL = BaseUrl + "admin/account/import";

          const payload = {
            data: rows,
            selectedFields: selectedFields,
          };

          http
            .post(URL, payload)
            .then((response) => {
              this.getAccounts();
              this.setState({
                isUploading: false,
                uploadMessage: "Customers Imported successfully!",
                showcustomPopup: true,
              });
            })
            .catch((error) => {
              console.log(error);
            });
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };
  closeCustomPopup = () => {
    this.setState({ showcustomPopup: false, uploadMessage: "" });
  };

  importButtonClick = (value) => {
    this.setState({ popupImportView: true, importValue: value });
  };

  importClosepopup = (event, shouldUpload, file, importValue, selectedFields) => {
    if (shouldUpload && file) {

      this.uploadFile(file, importValue, selectedFields);
    }
    this.setState({
      popupImportView: false,
      importValue: "",
      selectedFile: null,
    });
  };

  uploadFile = (file, importValue, selectedFields) => {
    // Implement the actual upload logic here
    // For example, using FileReader and axios as discussed earlier
    if (importValue === "Customer") {
      this.handleUpload(file, selectedFields);
    }
  };

  // Open confirmation or alert popup
  handleConfirmExportToExcel = () => {
    const records = this.state.accounts;
    if (!records || records.length === 0) {
      this.setState({ showNoDataAlert: true });
      return;
    }
    this.setState({ showExportAlert: true });
  };
  // Close popup without exporting
  handleCloseExportAlert = () => {
      this.setState({ showExportAlert: false });
  };
  handleCloseNoDataAlert = () => {
    this.setState({ showNoDataAlert: false });
  };
  // Export filtered records to Excel
  handleExportToExcel = () => {
    const records = this.state.accounts; // current filtered vendor records
    if (!records || records.length === 0) return;
    // Build dynamic first row text
    const rawStatus = this.state.statusFilterVal;
    const trimmed = typeof rawStatus === "string" ? rawStatus.trim() : "";
    let statusText = "All";
    if (trimmed && trimmed !== "") {
      const statusMapping = {
        "active": "Active",
        "deactive": "Inactive",
      };
      statusText = statusMapping[trimmed] || (trimmed.charAt(0).toUpperCase() + trimmed.slice(1));
    }
    const searchFieldMapping = {
        accountCode: "Account Code",
        accountName: "Account Name",
        accountEmail: "Email Address",
        accountPriceListId: "Price Band",
        Sectors: "Sector",
        mainDepot: "Main Depot",
        subDepot: "Local Depot"
    };
    const sortByMapping = {
      Ordered: "Ordered",
      "Not Ordered": "Not Ordered",
      lastLogin: "Last Login",
      createdAt: "Created on",
      updatedAt: "Updated on",
      "Intro Email Sent": "Intro Email Sent",
    };
    const firstFilterType = this.state.searchField ? searchFieldMapping[this.state.searchField] : null;
    const firstFilterValue = this.state.searchTextVal ? this.state.searchTextVal : null;
    const sortByText = this.state.sortBy && this.state.sortBy !== "all" ? sortByMapping[this.state.sortBy] : null;
    let dateRangeText = "";
    // If sort is selected, use applied date filter
    if (this.state.sortBy && this.state.sortBy !== "all") {
        if (this.state.period === "custom" && this.state.fromDate && this.state.toDate) {
            dateRangeText = `(${this.formatDate(this.state.fromDate)} - ${this.formatDate(this.state.toDate)})`;
        } else if (this.state.periodtext) {
            dateRangeText = `(${this.state.periodtext})`;
        }
    } else {
        // If sort is NOT selected, show default Past 30 Days
        dateRangeText = `(Past 30 Days)`;
    }
    // Construct first row string
    let firstRowText = "Tugo";
    // Add status first
    if (statusText) firstRowText += ` ${statusText}`;
    // Add "Customers" label
    firstRowText += ` Customers`;
    // Add sort next
    if (sortByText) firstRowText += ` - ${sortByText}`;
    // Prepare extra parts
    const parts = [];
    // Add grouping info if available
    if (firstFilterType && firstFilterValue)
      parts.push(`Grouped by ${firstFilterType} (${firstFilterValue})`);
    // Add total records and date range
    parts.push(`Total Records: ${records.length} ${dateRangeText}`);
    // Join all parts with " | "
    if (parts.length > 0) {
      firstRowText += ` | ${parts.join(" | ")}`;
    }
    // Headers (Account Code first, then Account Name, rest same)
    let headers = ["Account Code", "Account Name", "Email Address", "Price Band", "Sectors", "Sub Depot"];
    // If exporting ALL statuses, add a 'Status' column
    if (statusText === "All") {
      headers.push("Status");
    }
    const headerStyle = { font: { bold: true }, alignment: { horizontal: "left" } };
    const styledHeaders = headers.map(h => ({ v: h, s: headerStyle }));
    // Rows (same column order as headers)
    const rows = records.map(item => {
      console.log(item);
      const rowData = [
        item.accountCode,
        item.accountName,
        item.accountEmail,
        item.accountPriceListId,
        item.Sectors || "N/A",
        item.subDepot || "N/A"
      ];
      if (statusText === "All") {
      const rawStatus = (item.accountStatus || "").toString().trim().toLowerCase();
      let readableStatus = "Unknown";
      if (rawStatus === "active") readableStatus = "Active";
      else if (rawStatus === "deactive") readableStatus = "Inactive";
      rowData.push(readableStatus);
    }
      return rowData;
    });

    const worksheetData = [
        [{ v: firstRowText, s: { font: { bold: true }, alignment: { horizontal: "left" } } }],
        styledHeaders,
        ...rows
    ];
    // Dynamically calculate column widths like Orders report
    const columnWidths = headers.map((header, index) => {
        let maxLength = header.length;
        rows.forEach(row => { maxLength = Math.max(maxLength, String(row[index]).length); });
        return { wch: maxLength + 5 }; // +5 for extra padding
    });
    const ws = XLSX.utils.aoa_to_sheet(worksheetData);
    // Merge first row across all columns
    ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
    ws["!cols"] = columnWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Vendors");
    const exportDateTime = moment().format("DD-MM-YYYY");
    const fileName = `Customers Report-${exportDateTime}.xlsx`;
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
    saveAs(blob, fileName);
    this.setState({ showExportAlert: false });
  };

  callApiIfDatesSelected = () => {
    const { fromDate, toDate, sortBy } = this.state;
    if (fromDate && toDate) {
      // Close the date picker once both dates are selected
      this.setState({ showDatePicker: false });
      const payload = {
        filterby: sortBy,
        period: "custom",
        datefrom: format(new Date(fromDate), "yyyy-MM-dd"),
        dateto: format(new Date(toDate), "yyyy-MM-dd")
      };
      this.callApi(payload);
    }
  };
  // Function to handle API call
 callApi = (payload) => {
  if (payload.filterby === "createdAt" || payload.filterby === "updatedAt") {
    this.filterFromOriginalState(payload);
    return;
  }

  const URL = `${BaseUrl}admin/account`;
  this.setState({ loading: true });

    http.post(URL, payload)
      .then((response) => {
        let responseData = response.data.data;
       
        if(payload.filterby === "Not Ordered" || payload.filterby === "lastLogin") 
        {
          responseData = responseData.filter(
            (item) => !this.state.restrictedAccounts.includes(item.accountCode)
          );
        }
               
        this.setState({
          accounts: responseData,
          loading: false,
          tempaccounts: responseData,
          alertPopup: false,
          alertMessage: "",
        }, () => {
          // Call applyFilters after state is updated
          if (this.state.statusFilterVal || this.state.searchTextVal) {
            this.applyFilters();
          }
        }
        );
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          alertPopup: true,
          alertMessage: `The server is busy, please try again later.`,
          loading: false
        });
    });
};


filterFromOriginalState = (payload) => {
  let from, to;

  if (payload.period === "custom") {
    from = new Date(`${payload.datefrom}T00:00:00`);
    to = new Date(`${payload.dateto}T23:59:59`);
  } else {
    const days = parseInt(payload.period, 10);
    to = new Date();
    from = new Date();
    from.setDate(from.getDate() - days);
  }

  let filtered = this.state.originalAccounts.filter(account => {
    const dateToCompare = payload.filterby === "createdAt"
      ? new Date(account.createdAt)
      : new Date(account.updatedAt);

    return dateToCompare >= from && dateToCompare <= to;
  });

    filtered = filtered.filter(account => !this.state.restrictedAccounts.includes(account.accountCode));

  this.setState({
    accounts: filtered,
    tempaccounts: filtered,
    loading: false,
    alertPopup: false,
    alertMessage: "",
  }, () => {
    if (this.state.statusFilterVal || this.state.searchTextVal) {
      this.applyFilters();
    }
  });
};

  render() {
    const { showDatePicker, sortBy, fromDate, toDate } = this.state;

    if (sessionStorage.getItem("authData")) {
      var loginemail = JSON.parse(sessionStorage.getItem("authData")).adminEmail;
    }

    const columns = [
      {
        name: "Account Name",
        selector: (row) => row.accountName,
        sortable: true,
      },
      {
        name: "Account Code",
        selector: (row) => row.accountCode,
        sortable: true,
      },
      {
        name: "Email Address",
        selector: (row) => row.accountEmail,
        sortable: false,
      },
      {
        name: "Price Band",
        selector: (row) => row.accountPriceListId,
        sortable: true,
      },
      {
        name: "Sectors",
        selector: (row) => row.Sectors ? (!this.state.fullText ? <a
          className="title-tooltip title-up"
          data-title={row.Sectors}
        >
          <i className="fa fa-industry" aria-hidden="true"></i>
        </a> : row.Sectors) : "N/A",
        sortable: true,
      },
      {
        name: "Local Depot",
        selector: (row) => row.subDepot ? (!this.state.fullText ? <a
          className="title-tooltip title-up"
          data-title={row.subDepot}
        >
          <i className="fa fa-map-marker" aria-hidden="true"></i>
        </a> : row.subDepot) : "N/A",
        sortable: true,
      },
      {
        name: "Actions",
        selector: (row, index) => (
          <div>
            <a
              className="button title-tooltip title-up"
              data-title="View Details"
              style={{ color: "white" }}
              onClick={this.viewVendorDetails.bind(this, row)}
            >
              <i className="fa fa-eye" aria-hidden="true"></i>
            </a>
            {(loginemail === 'karthik@k2bsolutions.in' || loginemail === 'k2bsolutions@gmail.com') && (
              <>
              <a
              className="button title-tooltip title-up"
              data-title="Edit Details"
              style={{ color: "white" }}
              onClick={this.editVendorDetails.bind(this, row)}
            >
              <i className="fa fa-pencil" aria-hidden="true"></i>
            </a>
            <a
              className="button title-tooltip title-up"
              data-title="Change Password "
              style={{ color: "white" }}
              onClick={this.changePassword.bind(this, row)}
            >
              <i className="fa fa-key"></i>
            </a>
            </>
            )}
            
            <a
              className="button title-tooltip title-up"
              data-title="View Products"
              style={{ color: "white" }}
              onClick={this.viewProducts.bind(this, row)}
            >
              <i className="fa fa-gbp" aria-hidden="true"></i>
            </a>
            {(loginemail === 'karthik@k2bsolutions.in' || loginemail === 'k2bsolutions@gmail.com') && (<>
            <a
              className="button title-tooltip title-up"
              data-title="   Reset Password Email Trigger"
              style={{ color: "white" }}
              onClick={this.triggerEmail.bind(this, row)}
            >
              <i className="fa fa-envelope-o"></i>
            </a>
            </>
            )}
            <a
              className={`button title-tooltip title-up ${row.accountStatus === "active" ? "activate" : "deactivate"
                }`}
              data-title="Customer Activate/Deactivate"
              onClick={() => this.toggleCustomerStatus(row.accountCode)}
            >
              <i
                className={`fa ${row.accountStatus === "active" ? "fa-unlock" : "fa-lock"
                  }`}
              ></i>
            </a>
            <a
              className="button title-tooltip title-up"
              data-title="Customer Status Log"
              onClick={() => this.CustomerStatuslog(row.accountCode)}
            >
              <i className="fa fa-file-text-o"></i>
            </a>
            {(loginemail === 'karthik@k2bsolutions.in' || loginemail === 'k2bsolutions@gmail.com') && (<a
              className="button title-tooltip title-up"
              data-title="Delete Session"
              onClick={() => this.triggerSessionDelete(row.accountCode)}
            >
              <i className="fa fa-history"></i>
            </a>)}
          </div>
        ),

        sortable: false,
      },
    ];

    const customStyles = {
      rows: {
        style: {
          minHeight: "25px",
        },
      },
      headCells: {
        style: {
          padding: "8px", // override the cell padding for head cells
        },
      },
      cells: {
        style: {
          padding: "8px", // override the cell padding for data cells
        },
      },
    };

    const paginationComponentOptions = {
      rowsPerPageText: "",
      rangeSeparatorText: "",
      selectAllRowsItem: true,
      selectAllRowsItemText: "",
      noRowsPerPage: "",
    };

    
    return (
      <>

        {this.state.alertPopup == true && (
          <CommonAlert title="Alert" message={this.state.alertMessage} />
        )}

        <div className="dashboard-block">
          <Sidebar />

          <div className="dash-left">
            <Header />

            <section className="cart-block">
              <div className="container">
                <div className="flex-title">
                  <h1 className="checkout-title">Customers</h1>
                  <div className="prod-import-btn odr-expo-btn">
                  <a
                        data-title="Export Filtered Records"
                        className="export-btn button title-tooltip title-left"
                        onClick={this.handleConfirmExportToExcel}
                      >
                        Export
                  </a>
                  {(loginemail === 'karthik@k2bsolutions.in' || loginemail === 'k2bsolutions@gmail.com') && 
                    (
                    <>
                    {<a
                        data-title="Import Customer Records"
                        className="import-btn button title-tooltip title-left"
                        onClick={() => this.importButtonClick("Customer")}
                      >
                      Customer Import
                    </a>}</>)
                  }
                   
                  
                  </div>
                </div>

                <div className="right-table-outer-wrap vendors-table-wrap">
                  <div className="table-filter search-orders">
                  <div className="orders-drop-left customers-search">
                    <div className="orders-dropdown">
                      {/* Dropdown to select search field */}
                      <select
                        value={this.state.searchField}
                        onChange={(e) => this.handleFieldChange(e)}
                        className="form-control search-field"
                      >
                         <option value="" disabled>
                            Search by Field
                          </option>
                        <option value="accountCode">Account Code</option>
                        <option value="accountName">Account Name</option>
                        <option value="accountEmail">Email Address</option>
                        <option value="accountPriceListId">Price Band</option>
                        <option value="Sectors">Sectors</option>
                          <option value="mainDepot">Main Depot</option>
                          <option value="subDepot">Local Depot</option>
                        </select>
                      </div>
                      <div className="table-search-reset">
                        <div className="table-search search-input-wrapper">
                          {/* Show dropdown if "Sectors" is selected, otherwise show text input */}
                          {this.state.searchField === "mainDepot" &&
                            <select className="search-ord" onChange={(e) => this.handleChange(e.target.value)} value={this.state.searchTextVal}>
                              <option value="">Select</option>
                              {this.state.mainDepotList.map(item => (
                                <option key={item.mainDepot} value={item.mainDepot}>{item.mainDepot}</option>
                              ))}
                            </select>
                          }

                          {this.state.searchField === "subDepot" &&
                            <select className="search-ord" onChange={(e) => this.handleChange(e.target.value)} value={this.state.searchTextVal}>
                              <option value="">Select</option>
                              {this.state.subDepotList.map(item => (
                                <option key={item.subDepot} value={item.subDepot}>{item.subDepot}</option>
                              ))}
                            </select>
                          }

                          {this.state.searchField === "Sectors" &&
                            <select
                              value={this.state.searchTextVal}
                              onChange={(e) => this.handleChange(e.target.value)}
                              className="search-ord"
                            >
                              <option value="">Select Sector</option>
                              {this.state.sectorOptions && this.state.sectorOptions.length > 0 ? (
                                this.state.sectorOptions.map((sector, index) => (
                                  <option key={index} value={sector}>{sector}</option>
                                ))
                              ) : (
                                <option value="" disabled>No Sectors Available</option>
                              )}
                            </select>}

                          {this.state.searchField !== "Sectors" && this.state.searchField !== "mainDepot" && this.state.searchField !== "subDepot" && <input
                            type="text"
                            value={this.state.searchTextVal}
                            onChange={(e) => this.handleChange(e.target.value)}
                            className="form-control"
                            placeholder={`Search by ${this.state.searchFieldtxt}`}
                          />
                          }
                          {/* autosuggestion for priceband */}
                          {this.state.searchField === "accountPriceListId" &&
                            this.state.searchTextVal.trim() !== "" &&
                            this.state.suggestions.length > 0 && (
                              <ul className="suggestions-list">
                                {this.state.suggestions.map((item, index) => (
                                  <li key={index} onClick={() => this.handleSuggestionClick(item)}>
                                    {item}
                                  </li>
                                ))}
                              </ul>
                            )}
                          {/* autosuggestion for Sector and priceband */}
                        </div>
                        <button
                          className="submitbtn button search-cus-btn"
                          onClick={() => this.handleSearchClick()}
                        >
                          <i className="fa fa-search"></i>
                        </button>

                      <button
                        className="resetbtn"
                        type="reset"
                        onClick={this.handleReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                    
                    <div className="orders-dropdown vendor-select-drop">
                      <select
                        className="handle-srch"
                        value={sortBy}
                        onChange={(e) => this.handlesortbyChange(e.target.value)}
                      >
                        <option value="all">Show All Records</option> {/* Default option */}
                        <option value="Ordered">Ordered</option>
                        <option value="Not Ordered">Not Ordered</option>
                        <option value="lastLogin">Last Login</option>
                        <option value="createdAt">Created on</option>
                        <option value="updatedAt">Updated on</option>
                        <option value="Intro Email Sent">Intro Email Sent</option>
                        {/* <option value="Intro Email Not Sent">Intro Email Not Sent</option> */}
                      </select>
                      {!["all"].includes(sortBy) && (<div className="dropdown-container"
                        onMouseEnter={() => {
                          if (this.state.period === "custom" && !this.state.showDatePicker) {
                            this.setState({ showDatePicker: true });
                          }
                        }}
                        onMouseLeave={() => {
                          if (this.state.period === "custom" && this.state.showDatePicker) {
                            this.setState({ showDatePicker: false });
                          }
                        }}>
                        <select
                          className="handle-srch"
                          value={this.state.period}
                          onChange={(e) => this.handlesortChange(e.target.value,e.target.options[e.target.selectedIndex].text)}
                        >
                          <option value="">
                            Select
                          </option>
                          <option value="30">Past 30 Days </option>
                          <option value="90">Past 90 Days</option>
                          <option value="180">Past 180 Days</option>
                          <option value="365">Past 1 Year</option>
                          <option value="custom">Custom Date</option>
                        </select>
                        {showDatePicker && (
                          <div className="date-picker-container">
                            <label>From:</label>
                            <DatePicker
                              selected={fromDate}
                              onChange={(date) => this.DateChange(date, "from")}
                              showDisabledMonthNavigation
                              dateFormat="dd/MM/yyyy"
                              disablePast={true}
                              maxDate={new Date()}
                              // endDate={toDate}
                              // maxDate={toDate} // Prevent selecting a "From" date after "To" date
                              placeholderText="Select From Date"
                            />
                            <label>To:</label>
                            <DatePicker
                              selected={toDate}
                              showDisabledMonthNavigation
                              dateFormat="dd/MM/yyyy"
                              onChange={(date) => this.DateChange(date, "to")}
                              disablePast={true}
                              maxDate={new Date()}
                              // endDate={toDate}
                              //minDate={fromDate} // Prevent selecting a "To" date before "From" date
                              placeholderText="Select To Date"
                            />
                          </div>
                        )}

                      </div>)}
                      <select
                        value={this.state.statusFilterVal}
                        className="handle-srch"
                        onChange={(e) => this.handleStatusChange(e.target.value)}
                      >
                        <option value="" disabled>
                          Status
                        </option>
                        <option value=" ">All</option>
                        <option value="active">Active</option>
                        <option value="deactive">Inactive</option>
                      </select>
                    </div>
                  </div>


                  <div className="table_overflow vendor-list-table">
                    {/* Display selected dates as text when DatePicker is hidden */}
                    {sortBy != 'all' && this.state.period != '' && this.state.loading === false && this.state.accounts.length > 0 && (
                      <div className="selected-dates">
                        <p className="admin-order account-total-records">
                          Total Records:{" "}
                          {this.state.accounts.length > 0
                            ? this.state.accounts.length
                            : ""}
                          {
                            fromDate && toDate ? (
                              <span>
                                {" "}
                                (From {this.formatDate(
                                  fromDate
                                )}{" "}
                                to {this.formatDate(toDate)})
                              </span>
                            ) :  this.state.periodtext && this.state.periodtext!='Custom Date' ? (
                              ` (${this.state.periodtext})`
                            ) : (
                              ""
                            )
                          }
                        </p>
                      </div>
                    )}
                    <div className="full-text-toggle custom_check-box">
                      <div className="check-box">
                        <input
                          type="checkbox"
                          id="fullTextToggle"
                          checked={this.state.fullText}
                          onChange={() => this.setState({ fullText: !this.state.fullText })}
                        />
                      <label htmlFor="fullTextToggle">
                        Show Full Text (Sectors & Local Depot)
                      </label>
                      </div>
                    </div>
                    <DataTable
                      columns={columns}
                      noDataComponent={
                        <div className="no-records-found">
                          Sorry, no customers were matching your keyword, try a
                          new search.
                        </div>
                      }
                      data={this.state.accounts}
                      customStyles={customStyles}
                      pagination
                      paginationPerPage={25}
                      progressPending={this.state.loading}
                      paginationRowsPerPageOptions={[25, 50, 75, 100]}
                      paginationComponentOptions={paginationComponentOptions}
                    />
                  </div>
                </div>
              </div>
            </section>
            <Footer />
          </div>
          {this.state.showDialog && (
            <div className="custom-alert-pop paylater-popup">
              <div className="custom-alert-container">
                <div className="custom-alert-wrap">
                  <div className="custom-alert-header">
                    <h4>Alert</h4>
                  </div>
                  <div className="custom-alert-body">
                    <p>
                      {this.state.confirmationAction.action === "activate" ? (
                        this.state.isEmailToBeSent === "yes" ? (
                          <>Are you sure you want to activate customer ({this.state.confirmationAction.accountcode}) and send the introduction email?</>
                        ) : (
                          <>Are you sure you want to activate the customer ({this.state.confirmationAction.accountcode}) without  introduction email?</>
                        )
                        ) : (
                          <>Are you sure you want to deactivate customer ({this.state.confirmationAction.accountcode})?</>
                      )}
                      </p>
                    <div className="alert-buttons">
                      <button
                        onClick={this.confirmActionHandler}
                        className="popup-alert-btn button"
                      >
                        Yes
                      </button>
                      <button
                        onClick={this.hideConfirmationDialog}
                        className="popup-alert-btn button"
                      >
                        No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {this.state.showReasonPopup && (
            <div className="custom-alert-pop paylater-popup">
              <div className="custom-alert-container">
                <div className="custom-alert-wrap">
                  <div className="custom-alert-header">
                    <h4>{this.state.confirmationAction.action} ({this.state.confirmationAction.accountcode})</h4>
                  </div>
                  <div className="custom-alert-body text-left">
                    {/* Radio Buttons */}
                    {this.state.confirmationAction.action === "activate" && (
                      <div className="input-field">
                        
                        <label htmlFor="emailOption">How Would You Like to Activate?</label>
                        <select
                          id="emailOption"
                          name="emailOption"
                          value={this.state.isEmailToBeSent}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            this.setState({ isEmailToBeSent: selectedValue, emailError: false });

                            // Fetch email count only if "Activate with Intro Email" is selected
                            if (selectedValue === "yes") {
                              const emailCountURL = BaseUrl + "admin/emailcount"; // Replace with actual endpoint
                              const payload = { accountCode: this.state.confirmationAction.accountcode };

                              http.post(emailCountURL, payload)
                                .then((response) => {
                                  const count = response.data.data || 0;
                                  this.setState({ emailCount: count });
                                })
                                .catch((error) => {
                                  console.error("Error fetching email count:", error);
                                  this.setState({ emailCount: "Error fetching count" });
                                });
                            } else {
                              // Reset email count if "Activate without Intro Email" is selected
                              this.setState({ emailCount: null });
                            }
                          }}
                        >
                          <option value="">Select Activation Option</option>
                          <option value="yes">Activate with Intro Email</option>
                          <option value="no">Activate without Intro Email</option>
                        </select>
                             {this.state.isEmailToBeSent === "yes" && (
                              <div className="input-info-msg">
                                <strong>Intro email previously sent: </strong>
                                {this.state.emailCount !== null
                                  ? this.state.emailCount
                                  : <div className="loading-dots">
                                        <div className="dot-small"></div>
                                        <div className="dot-small"></div>
                                        <div className="dot-small"></div>
                                    </div>}
                              </div>
                            )}
                        {this.state.emailError && (
                          <div className="error-msg">This field is required</div>
                        )}
                      </div>
                    )}
                    <div className="input-field">
                      <span className="labeltxt">Post your comments</span>
                      <textarea
                        name="reason"
                        onChange={(e) =>
                          this.handleReasonChange(e.target.value)
                        }
                      ></textarea>
                      {this.state.reasonError && (
                        <div className="error-msg">This field is required</div>
                      )}
                    </div>

                    <div className="alert-buttons">
                      <button
                        onClick={this.showConfirmationDialog}
                        className="popup-alert-btn button"
                      >
                        Submit
                      </button>
                      <button
                        onClick={this.hideConfirmationDialog}
                        className="popup-alert-btn button"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {this.state.showcustomPopup && (
            <div className="custom-alert-pop paylater-popup">
              <div className="custom-alert-container">
                <div className="custom-alert-wrap">
                  <div className="custom-alert-header">
                    <h4>Alert</h4>
                  </div>
                  <div className="custom-alert-body">
                    <p>{this.state.uploadMessage}</p>

                    <div className="alert-buttons">
                      <button
                        onClick={this.closeCustomPopup}
                        className="popup-alert-btn button"
                      >
                        ok
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {this.state.popupView}
          {this.state.popuplogView}
          {this.state.popupPricebandView}
          {this.state.editvendor && (
            <EditvendorDetails
              VendorDetails={this.state.VendorDetails}
              popupclose={this.editclosepopup}
              editvendorDetails={this.ediVendorsdetails}
            />
          )}
          {this.state.showPopup && (
            <ChangePassword
              popupclose={this.closepopup}
              emailadd={this.state.Vendoremailadd}
              accCode={this.state.Vendoraccountcode}
            />
          )}

          {this.state.popupImportView && (
            <CustomerImport
              closePopup={this.importClosepopup}
              impValue={this.state.importValue}
            />
          )}
          {this.state.isUploading && (
            <div className="loading-overlay">
              <div className="loading-message">Importing...</div>
            </div>
          )}
        </div>
        {this.state.visibleAlert === true && (
          <div className="custom-alert-pop paylater-popup">
            <div className="custom-alert-container">
              <div className="custom-alert-wrap">
                <div className="custom-alert-header">
                  <h4>Alert</h4>
                </div>
                <div className="custom-alert-body">
                  <p>Are you sure you want to send reset password link?</p>

                  <div className="alert-buttons">
                    <a
                      onClick={this.triggerMail.bind(this)}
                      className="popup-alert-btn button"
                    >
                      OK
                    </a>
                    <a
                      onClick={this.alertPopupclose.bind(this)}
                      className="popup-alert-btn button"
                    >
                      Cancel
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {this.state.visibledeleteAlert === true && (
          <div className="custom-alert-pop paylater-popup">
            <div className="custom-alert-container">
              <div className="custom-alert-wrap">
                <div className="custom-alert-header">
                  <h4>Delete Session</h4>
                </div>
                <div className="custom-alert-body">
                  <p>Are you sure you want to delete the session for {" "} {this.state.customeraccount}?</p>

                  <div className="alert-buttons">
                    <a
                      onClick={this.triggerDelete.bind(this)}
                      className="popup-alert-btn button"
                    >
                      OK
                    </a>
                    <a
                      onClick={this.DeletePopupclose.bind(this)}
                      className="popup-alert-btn button"
                    >
                      Cancel
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.showExportAlert && (
          <div className='custom-alert-pop paylater-popup'>
            <div className='custom-alert-container'>
              <div className='custom-alert-wrap'>
                <div className='custom-alert-header'>
                  <h4>Alert</h4>
                </div>
                <div className='custom-alert-body'>
                  <p>Are you sure you want to export the customer report?</p>
                  <div className='alert-buttons'>
                    <a onClick={this.handleExportToExcel} className="popup-alert-btn button">OK</a>
                    <a onClick={this.handleCloseExportAlert} className="popup-alert-btn button">Cancel</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.showNoDataAlert && (
          <div className='custom-alert-pop paylater-popup'>
            <div className='custom-alert-container'>
              <div className='custom-alert-wrap'>
                <div className='custom-alert-header'>
                  <h4>Alert</h4>
                </div>
                <div className='custom-alert-body'>
                  <p>There is no customer records available for export.</p>
                  <div className='alert-buttons'>
                    <a onClick={this.handleCloseNoDataAlert} className="popup-alert-btn button">OK</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default Vendors;
